import { z } from 'zod';
import { decimalStringSchema, isoDateSchema, isoDateTimeSchema, positiveDecimalStringSchema, uuidSchema, } from './common.js';
import { mealSlotSchema } from './enums.js';
export const mealPlanEntrySchema = z.object({
    id: uuidSchema,
    householdId: uuidSchema.nullable(),
    date: isoDateSchema,
    slot: mealSlotSchema,
    customSlotName: z.string().nullable(),
    recipeId: uuidSchema.nullable(),
    recipeTitle: z.string().nullable(),
    recipeThumbnailUrl: z.string().nullable(),
    title: z.string().nullable(),
    servings: decimalStringSchema.nullable(),
    note: z.string().nullable(),
    position: z.number().int(),
    version: z.number().int(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const mealPlanEntryWriteSchema = z
    .object({
    householdId: uuidSchema.nullable().optional(),
    date: isoDateSchema,
    slot: mealSlotSchema,
    customSlotName: z.string().trim().max(40).nullable().optional(),
    recipeId: uuidSchema.nullable().optional(),
    title: z.string().trim().max(200).nullable().optional(),
    servings: positiveDecimalStringSchema.nullable().optional(),
    note: z.string().trim().max(1000).nullable().optional(),
    position: z.number().int().min(0).optional(),
})
    .refine((v) => v.recipeId || v.title, { message: 'Either recipeId or title is required' });
export const mealPlanEntryUpdateSchema = z.object({
    date: isoDateSchema.optional(),
    slot: mealSlotSchema.optional(),
    customSlotName: z.string().trim().max(40).nullable().optional(),
    recipeId: uuidSchema.nullable().optional(),
    title: z.string().trim().max(200).nullable().optional(),
    servings: positiveDecimalStringSchema.nullable().optional(),
    note: z.string().trim().max(1000).nullable().optional(),
    position: z.number().int().min(0).optional(),
    version: z.number().int().nonnegative(),
});
export const mealPlanQuerySchema = z.object({
    from: isoDateSchema,
    to: isoDateSchema,
    householdId: uuidSchema.optional(),
});
export const mealPlanWeekSchema = z.object({
    from: isoDateSchema,
    to: isoDateSchema,
    entries: z.array(mealPlanEntrySchema),
});
export const mealPlanToShoppingListRequestSchema = z.object({
    from: isoDateSchema,
    to: isoDateSchema,
    householdId: uuidSchema.nullable().optional(),
    /** Existing list to append to, or null to create a new one. */
    shoppingListId: uuidSchema.nullable().optional(),
    listName: z.string().trim().max(120).optional(),
    subtractPantry: z.boolean().default(false),
});
//# sourceMappingURL=meal-plan.js.map